import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SectionTabs, { SectionTab } from '../components/SectionTabs';
import { PageHeader } from '../components/ui';
import Inventory from './Inventory';
import ExternalInventory from './ExternalInventory';
import InventoryTransactions from './InventoryTransactions';

const INVENTORY_TABS: SectionTab[] = [
  { id: 'inventory', label: 'Inventory' },
  { id: 'external', label: 'External Sources' },
  { id: 'transactions', label: 'Transaction History' }
];

const InventorySection: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const current = searchParams.get('tab');
  const validIds = INVENTORY_TABS.map((t) => t.id);
  const activeTab = validIds.includes(current || '') ? (current as string) : 'inventory';

  const handleTabChange = (id: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="space-y-7">
      <PageHeader
        title="Inventory"
        subtitle="Track bottle stock, external sources, and transaction history."
      />

      <SectionTabs
        tabs={INVENTORY_TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <div>
        {activeTab === 'inventory' && <Inventory tabVisible />}
        {activeTab === 'external' && <ExternalInventory tabVisible />}
        {activeTab === 'transactions' && <InventoryTransactions tabVisible />}
      </div>
    </div>
  );
};

export default InventorySection;
